export default {
  styleOverrides: {
    root: {
      transition: 'fill .15s ease',
      path: {
        transition: 'fill .15s ease',
      },
    },
  },
};
